import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { Router } from '@angular/router';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CommonService } from 'src/app/shared/utils/common.service';

@Component({
  selector: 'app-device-added',
  templateUrl: './device-added.component.html',
  styleUrls: ['./device-added.component.scss'],
})
export class DeviceAddedComponent implements AfterViewInit {
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @ViewChild('modalAddDevice') deviceAddRef!: ElementRef;
  @Output() stepperChange = new EventEmitter<number>();

  readonly LANG_CONST = LANG_CONST;

  constructor(public commonService: CommonService, private router: Router) {}

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    const currentUrl = this.router.url;
    this.dialogRef?.close();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      if (window.__dev__) console.log('Navigating back to', currentUrl);
      this.router.navigateByUrl(currentUrl);
    });
  }
  ngAfterViewInit(): void {
    if (this.deviceAddRef) {
      this.deviceAddRef.nativeElement.focus();
    }
  }
  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateBack(): void {
    this.dialogRef.close();
  }
}
